import { render, staticRenderFns } from "./new-authorization.component.vue?vue&type=template&id=41dff965&scoped=true"
import script from "./new-authorization.component.vue?vue&type=script&lang=js"
export * from "./new-authorization.component.vue?vue&type=script&lang=js"
import style0 from "./new-authorization.component.vue?vue&type=style&index=0&id=41dff965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dff965",
  null
  
)

export default component.exports